<template>
    <div class="m-propertyalerts">
        <div class="e-close">
            <span>&times;</span>
            Close
        </div>
        <div class="popup">
            <div class="text">
                <h3>Property Alerts</h3>
                <p>Select the areas of interest for personalised alerts.</p>
            </div>
            <div class="m-form">
                <form action="#" v-if="viewModel && viewModel.RegionOptions">
                    <div class="form-row" v-if="!isLoggedIn">
                        <label for="property-alert-email">Email address <span class="indicator">*</span></label>
                        <input type="email" name="email" id="property-alert-email" v-model="viewModel.Email">
                    </div>
                    <div class="form-row" v-for="region in viewModel.RegionOptions" :key="region.Value">
                        <div class="checkbox">
                            <input type="checkbox" :id="'property-alert-region-' + region.Value" :name="'property-alert-region-' + region.Value" v-model="region.Selected">
                            <label :for="'property-alert-region-' + region.Value">{{region.Text}}</label>
                        </div>
                    </div>
                    <div class="form-nav">
                        <button class="btn btn-green" v-on:click.prevent="Update">Add preferences</button>
                        <p v-if="propertyAlertsUpdated">Property alerts updated</p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Axios from 'axios'

    export default {
        computed: {
            isLoggedIn: function () {
                return isLoggedIn
            }
        },

        created: function () {
            this.Init()
        },

        data() {
            return {
                loading: false,
                propertyAlertsUpdated: false,
                viewModel: null
            }
        },

        methods: {
            Init: function () {
                var vm = this

                vm.loading = true

                const getPropertyAlertsViewModel = function () {
                    return Axios.get(
                        '/umbraco/api/PropertyAlertsApi/Get', { params: { currentPageId: currentPageId } })
                }

                Axios.all([getPropertyAlertsViewModel()])
                    .then(Axios.spread(function (response) {

                        if (response && response.data) {
                            vm.viewModel = response.data
                        }

                        vm.loading = false
                    }))
                    .catch(() => {
                        vm.loading = false
                    })
            },

            Update: function () {
                var vm = this
                vm.propertyAlertsUpdated = false
                vm.loading = true

                const updatePropertyAlerts = function () {
                    return Axios.post(
                        '/umbraco/api/PropertyAlertsApi/Update', vm.viewModel)
                }

                Axios.all([updatePropertyAlerts()])
                    .then(Axios.spread(function () {

                        vm.propertyAlertsUpdated = true
                        vm.loading = false
                    }))
                    .catch(() => {

                        vm.loading = false
                    })
            }
        }
    }
</script>